/*
 * Fila de tarjetas KPI, réplica del .kpi del HTML original
 */
import { Description, Title } from "codekit";

import { htmlTheme } from "./utils/carthelp";

/**
 * Renderiza una tarjeta KPI individual
 * @param {Object} props Propiedades de la tarjeta
 * @param {string} props.label Etiqueta superior
 * @param {string} props.value Valor principal
 * @param {string} props.delta Texto secundario opcional
 */
const KpiCard = ({ label, value, delta }) => (
  <div
    style={{
      flex: 1,
      minWidth: 220,
      background: htmlTheme.card,
      borderRadius: 14,
      padding: "16px 18px",
      border: `1px solid ${htmlTheme.border}`,
      borderLeft: `5px solid ${htmlTheme.navy2}`,
      boxShadow: "0 1px 3px rgba(20,30,70,.06)",
    }}
  >
    <div style={{ color: htmlTheme.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>
      <Description variant="description-4">{label}</Description>
    </div>
    <div style={{ color: htmlTheme.navy2, marginTop: 6 }}>
      <Title variant="title-1">{value}</Title>
    </div>
    {delta ? (
      <div style={{ color: htmlTheme.muted, marginTop: 5 }}>
        <Description variant="description-3">{delta}</Description>
      </div>
    ) : null}
  </div>
);

/**
 * Renderiza la fila de tarjetas KPI
 * @param {Object} props Propiedades del componente
 * @param {Array} props.kpis Lista de KPIs [{ label, value, delta }]
 */
const Kpicards = ({ kpis = [] }) => (
  <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 20 }}>
    {kpis.map((mKpi, nIndex) => (
      <KpiCard key={nIndex} label={mKpi.label} value={mKpi.value} delta={mKpi.delta} />
    ))}
  </div>
);

export default Kpicards;
